import type { InputHTMLAttributes } from 'react'

/** Disable Lastpass and Dashlane and other autocompletes */
export const disableAutocomplete: InputHTMLAttributes<HTMLInputElement> = {
  autoComplete: 'off',
  /** @see https://dashlane.github.io/SAWF/#mozTocId902224 */
  // dataFormType: 'other',
  // dataLpignore: true,
}
